import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import { BaseApiService } from "./base-api.service";

@Injectable({
  providedIn: "root",
})
export class PersonaService extends BaseApiService {
  constructor(protected http: HttpClient) {
    super(http);
  }

  public setImpersonation(employeeId): Observable<any> {
    return this.put("/employee/me/impersonation/" + employeeId).pipe(map((r) => console.log(r)));
  }

  public clearImpersonation(): Observable<any> {
    return this.delete("/employee/me/impersonation/").pipe(map((r) => console.log(r)));
  }
}
